// import config from '../server/config'
import localforage from 'localforage';
import { fetchPageData } from './fetchPageData';

export default async function  FetchHook({offset,limit}) {
    // let location = useLocation()
    // const [hookRes,setHookRes] = useState([])
    const authData = await localforage.getItem('AuthenticationStore')
    let cancel;
    let hookRes = []				
    let endpoint = window?.cachedAPI
    let parsedCountryCode = window.app_data?.countryCode || "IN" //(countryCode && countryCode.country && (countryCode.country).toLowerCase()) || ""
    let variables = {
      site: (window?.app_data?.site?.siteInternalName) || null,
      path: window?.location?.pathname,
      device: "WEB",
      includeContent: true,
      moduleLimit: limit,
      moduleOffset: offset,
      languageCode: "en",
      countryCode: parsedCountryCode,
      userState: authData ? authData?.user?.userState : window.btoa(JSON.stringify({ "state": ["loggedOut"] })),
      modules: []
    }
    return fetchPageData(variables,endpoint)
    // return () => cancel()
  
}